<div class="stats-page flex flex-col min-h-0 h-full pt-4">
  <div class="stats-header">
    <button
      mat-flat-button
      color="primary"
      class="statics-settings-btn"
      (click)="openStatics()"
    >
      {{ 'STATICS.OPEN_SETTINGS' | translate }}
    </button>
  </div>

  <ng-template #modalStatics>
    <h2 mat-dialog-title>{{ 'STATICS.SETTINGS_TITLE' | translate }}</h2>
    <mat-dialog-content class="statics-dialog-content">
      <div class="fields-row wide">
        <div class="field-col equal">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ 'STATICS.PERIOD' | translate }}</mat-label>
            <mat-date-range-input
              [rangePicker]="pickerRange"
              (click)="pickerRange.open()"
            >
              <input
                matStartDate
                name="dateStart"
                cdkFocusInitial
                [(ngModel)]="dateRange.start"
                placeholder="{{ 'STATICS.START' | translate }}"
              />
              <input
                matEndDate
                name="dateEnd"
                [(ngModel)]="dateRange.end"
                placeholder="{{ 'STATICS.END' | translate }}"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerRange"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #pickerRange></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="field-col equal">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ 'STATICS.FINCA' | translate }}</mat-label>
            <mat-select
              [value]="finca"
              (selectionChange)="finca = $event.value; fincaChange()"
            >
              <mat-option [disabled]="fincas.length === 0" [value]="-1">{{
                'STATICS.NO_FINCAS' | translate
              }}</mat-option>
              <mat-option
                *ngFor="let fincaItem of fincas"
                [value]="fincaItem.idFinca"
              >
                {{ fincaItem.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field-col equal">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ 'STATICS.MODULE' | translate }}</mat-label>
            <mat-select
              [value]="modulo"
              (selectionChange)="modulo = $event.value; moduloChange()"
            >
              <mat-option [disabled]="modulos.length === 0" [value]="-1">{{
                'STATICS.NO_MODULES' | translate
              }}</mat-option>
              <mat-option
                *ngFor="let moduloItem of modulos"
                [value]="moduloItem.idModule"
              >
                {{ moduloItem.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="fields-row" *ngIf="showHumSettings">
        <div class="field-col">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ 'STATICS.SOIL_MOISTURE' | translate }}</mat-label>
            <mat-select
              multiple
              [value]="humind"
              (selectionChange)="humind = $event.value"
            >
              <mat-option
                *ngFor="let depth of humidityDepthOptions"
                [value]="depth"
                >{{ getHumidityOptionLabel(depth) }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field-col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'STATICS.SUMMARY' | translate }}</mat-label>
            <mat-select
              multiple
              [value]="humsum"
              (selectionChange)="humsum = $event.value"
            >
              <mat-option
                *ngFor="let depth of humidityDepthOptions"
                [value]="depth"
                >{{ getHumidityOptionLabel(depth) }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field-col" *ngIf="hasEnviropro8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'STATICS.CONDUCTIVITY' | translate }}</mat-label>
            <mat-select
              multiple
              [value]="conductivitySelected"
              (selectionChange)="conductivitySelected = $event.value"
            >
              <mat-option
                *ngFor="let depth of conductivityDepthOptions"
                [value]="depth"
                >{{ depth }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="sensors-grid">
        <div class="sensor-col" *ngFor="let sensor of sensores; let i = index">
          <label class="sensor-label">{{ i + 1 }}. {{ sensorNames[i] }}</label>
          <mat-radio-group
            color="primary"
            [ngModel]="sensorGraphs[i]?.value"
            (ngModelChange)="updateSensorSelection($event, sensorGraphs[i])"
            [ngModelOptions]="{ standalone: true }"
            class="radio-column"
          >
            <mat-radio-button [value]="0">{{
              'STATICS.NO' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="1">G1</mat-radio-button>
            <mat-radio-button [value]="2">G2</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        mat-icon-button
        type="button"
        class="compare-lock-btn"
        color="primary"
        [attr.aria-label]="
          (compareLocked
            ? 'STATICS.COMPARE_UNLOCK_CLEAR'
            : 'STATICS.COMPARE_LOCK') | translate
        "
        [matTooltip]="
          (compareLocked
            ? 'STATICS.COMPARE_UNLOCK_CLEAR'
            : 'STATICS.COMPARE_LOCK') | translate
        "
        (click)="toggleCompareLock()"
      >
        <mat-icon>{{ compareLocked ? 'lock' : 'lock_open' }}</mat-icon>
      </button>
      <button mat-button (click)="dialogRef?.close()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="saveModal()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <div #mainGraficas class="stats-body flex-1 min-h-0">
    <div *ngIf="!hasPrimaryChart" class="empty-alert">
      {{ 'STATICS.NO_DATA' | translate }}
    </div>

    <div
      *ngIf="hasPrimaryChart"
      class="chart-grid h-full"
      [ngClass]="{
        'md:grid-cols-2': hasSecondChart,
        'has-two': hasSecondChart
      }"
    >
      <div class="card chart-card">
        <div class="chart-viewport">
          <div #chart1Container id="chart1" class="chart-host"></div>
        </div>
      </div>

      <div *ngIf="hasSecondChart" class="card chart-card">
        <div class="chart-viewport">
          <div #chart2Container id="chart2" class="chart-host"></div>
        </div>
      </div>
    </div>
  </div>
</div>
